export default __webpack_public_path__ + "static/media/KOD0143-min.1da9a46d.webp";